import React from 'react';
import { Image } from 'react-konva';
import {
  isMobileTablet,
} from '../../library/calc';
import {
  cachetree,
} from '../../library/constants';

const adjustTop = 22.5;
const adjustLeft = 24.6;
export class Plus extends React.Component {

  constructor(props){
    super(props);
    this.props.buildRefObj({key: `add_n-${this.props.node}`, objClass: this});
    this.state = {
      fileName: 'addnodetabImage',
    }
  }

  componentDidUpdate(){
    if(cachetree){
      this.refs.plusNodeCache.cache();
    }
  }

  swapImage({fileName}){
    this.setState({fileName});
  }

  click(evt){
    this.props.stopStageClickPropagation({fromWhere: 'addNodeComponent'});
    this.props.onclickedAddNodeTab(this.props.node);
  }

  render() {

    let {
      ntm,
      left,
      top,
      node,
      cursorBecomesMove,
      cursorBecomesPointer,
      onclickedAddNodeTab,
      stopStageClickPropagation,
      userTouchedNode,
      hideMatchBubble,
    } = this.props;

    left += adjustLeft;
    top += adjustTop + 6.5;

    return (
        <Image
          ref={'plusNodeCache'}
          image={this.props[`${this.state.fileName}`]}
          scaleX={.1}
          scaleY={.1}
          width={21*10}
          height={5.5*10}
          x={left}
          y={top}

          onTouchStart={()=>{
            userTouchedNode({
              node,
              callback: ()=>{
                if(isMobileTablet()) {
                  stopStageClickPropagation({fromWhere: 'addNodeComponent'});
                  onclickedAddNodeTab(node);
                  return;
                }
              },
              fromWhere: 'addnode component'});
          }}

          onMouseover={()=>{
            hideMatchBubble();
          }}

          onClick={this.click.bind(this)}

          onMouseenter={()=>{
            if( typeof(ntm) !== 'undefined' && ntm){
              this.swapImage({fileName:'addnodetabRedImage'});
            } else {
              this.swapImage({fileName:'addnodetabGreenImage'});
            }
            cursorBecomesPointer();
          }}

          onMouseleave={()=>{
            this.swapImage({fileName:'addnodetabImage'});
            cursorBecomesMove();
          }}
        />
    );
  }
}

